<template>
  <!-- 上传商品描述附件 -->
  <el-dialog
    title="上传商品描述附件"
    :visible.sync="productDescVisible"
    width="506px"
    :before-close="cancelHandle"
    :close-on-click-modal="false"
    append-to-body
    class="product-desc-dia"
  >
    <el-form :model="productDescForm" ref="productDescForm" size="small">
      <el-form-item label="描述附件：" label-width="100px" prop="">
        <el-upload
          ref="uploadFile"
          class="upload-demo"
          :file-list="fileList"
          :http-request="uploadFile"
          :auto-upload="false"
          :on-change="onChange"
          :on-success="handleFileSuccess"
          :before-remove="beforeRemove"
          :on-remove="handleRemove"
          :headers="headers"
          name="originalFilename"
          action=""
          :limit="limit"
          :on-exceed="handleExceed"
        >
          <eui-btn type="primary">选择文件</eui-btn>
        </el-upload>
      </el-form-item>
      <el-form-item style="margin: 0">
        <div class="hint">
          提示：支持xls、xlsx、doc、docx、pdf、jpg、jpeg、png格式的文件，最多可上传1个，大小小于30M，为了保证用户信息安全，附件中不要包含个人信息。
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <eui-btn type="secondary" @click="cancelHandle">取 消</eui-btn>
      <eui-btn
        :loading="btnLoading"
        type="primary"
        @click="submitUpload"
      >
        确定
      </eui-btn>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry';
import EuiBtn from "epec-ui/src/package/eui-btn/index";
export default {
  components: {EuiBtn},
  props: {
    limit: {
      type: Number,
      default: 1
    },
    fileSize: {
      type: Number,
      default: 30
    },
    productDescVisible: {
      type: Boolean,
      default: false
    },
    showFileList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      btnLoading: false,
      fileList: [],
      headers: {},
      productDescForm: {
        desc: ''
      }
    };
  },
  watch: {
    productDescVisible(oldVal, newVal) {
      console.log(oldVal, newVal);
      if (oldVal) {
        /* this.showFileList.forEach(item => {
          if (!item.fileName || !item.url) {
            return false;
          }
        }); */
        for (const item of this.showFileList) {
          if (!item.name || !item.url) {
            return;
          }
        }
        console.log(this.showFileList, 'this.showFileListthis.showFileList');
        this.fileList = [...this.showFileList];
      }
    }
  },
  methods: {
    // 上传文件提交
    submitUpload() {
      // {fileName/url}
      // 执行文件上传的函数，其实也就是调用 uploadFile方法 来获取我们要上传的文件
      this.$refs.uploadFile.submit();
      if (this.fileList.length !== 1) {
        this.$message({
          message: '请选择需要上传的文件!',
          type: 'error'
        });
        return;
      }
      // 通过 FormData 对象上传文件
      const file = new FormData();
      this.fileList.forEach(function(item) {
        // 因为要上传多个文件，所以需要遍历
        file.append('file', item, item.name);
        // formdata.append('name', 'lbf-file-upload')
      });
      console.log(file, 'file');
      this.btnLoading = true;
      Api.enquiryFileUpload(file)
        .then(res => {
          this.btnLoading = false;
          if (res.code === '200') {
            console.log(res, 'resresresres');
            this.$emit('getProductDescFile', res.data);
            this.cancelHandle();
          }
        })
        .finally(() => {
          this.uploadLoading = false;
          // this.$refs.uploadFile.clearFiles();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 关闭弹窗与取消
    cancelHandle() {
      this.$emit('update:productDescVisible', false);
      this.fileList.splice(0, 1);
      this.$refs.uploadFile.clearFiles();
    },
    // 文件超出个数限制时的钩子
    handleExceed() {
      this.$message.error(`当前限制选择 ${this.limit} 个文件`);
    },
    // 文件fliesize及格式校验
    isFileSize(file) {
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message({
          message: `请上传小于${this.fileSize}M的文件!`,
          type: 'error'
        });
        return false;
      }
      if (file.name.includes(',')) {
        this.$message({
          message: '文件名格式错误!',
          type: 'error'
        });
        return false;
      }
      return true;
    },
    // 以下是上传文件需要的方法
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },

    // 验证调删除事件时的文件规则
    fileFormat(file) {
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      const isDoc = testmsg === ' doc';
      const isDocx = testmsg === 'docx';
      const isPdf = testmsg === 'pdf';
      const isJpg = testmsg === 'jpg';
      const isJpeg = testmsg === 'jpeg';
      const isPng = testmsg === 'png';
      return (
        isXls || isXlsx || isDoc || isDocx || isPdf || isJpg || isJpeg || isPng
      );
    },
    // 改变文件的钩子
    onChange(file, fileList) {
      if (!this.isFileSize(file)) {
        this.$message.closeAll();
        this.$message({
          message: `上传文件大小不能超过 ${this.fileSize}MB!`,
          type: 'error'
        });
        return false;
      }
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      const isDoc = testmsg === ' doc';
      const isDocx = testmsg === 'docx';
      const isPdf = testmsg === 'pdf';
      const isJpg = testmsg === 'jpg';
      const isJpeg = testmsg === 'jpeg';
      const isPng = testmsg === 'png';
      // 避免有些是手动上传文件，直接在on-change上进行文件校验
      if (
        !isXlsx &&
        !isXls &&
        !isDoc &&
        !isDocx &&
        !isPdf &&
        !isJpg &&
        !isJpeg &&
        !isPng
      ) {
        this.$message({
          message:
            '上传文件只能是xls、xlsx、doc、docx、pdf、jpg、jpeg、png格式!',
          type: 'error'
        });
        fileList.length && this.$refs.uploadFile.clearFiles();
        return false;
      }
      console.log('改变文件的钩子', fileList);
      // 只能上传excel
      return (
        isXls || isXlsx || isDoc || isDocx || isPdf || isJpg || isJpeg || isPng
      );
    },
    // 上传成功的钩子
    handleFileSuccess(response, file, fileList) {
      console.log(response, 'response');
      /* this.$refs.uploadFile.clearFiles();
      // 不管成功还是失败都将弹窗中选择的文件清空
      for (let index = 0; index < fileList.length; index++) {
        fileList.splice(index, 1);
      }
      this.fileList = []; */
      console.log(file, fileList, '上传成功的钩子111');
    },
    // 移除前的钩子
    beforeRemove(file) {
      console.log(file, '移除前的钩子');
      if (this.fileFormat(file)) {
        // 删除提示
        return this.$confirm(`确定永久移除 ${file.name}？`, '提示');
      }
    },
    // 上传失败的钩子
    errFunction(file, fileList) {
      console.log(file, fileList);
      this.$message.error('上传失败');
    },
    // 移除的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList.splice(0, 1);
      this.$refs.uploadFile.clearFiles();
    },
    // 这里就是的到需要上传文件的集合
    uploadFile(params) {
      const file = params.file;
      this.fileList.push(file);
    }
  }
};
</script>
<style lang="scss" scoped>
.product-desc-dia {
  .hint {
    margin-left: 30px;
    word-wrap: break-word;
    color: #666666;
    font-size: 14px;
    line-height: 1.3;
  }
  ::v-deep .el-button {
    border-radius: 0;
    min-width: 80px;
    height: 30px;
  }

  ::v-deep .el-dialog__body {
    padding: 20px 10px 10px 10px;
  }
  ::v-deep .el-dialog__header {
    background: #f5f5f5;
    height: 40px;
    padding: 0 20px;
    line-height: 40px;
    .el-dialog__headerbtn {
      top: 8px;
    }
    .el-dialog__title {
      font-size: 14px;
    }
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .el-button {
      border-radius: 0;
      min-width: 80px;
      height: 30px;
    }
  }
}
</style>
